import { companyProfileSchema } from '../../../../shared/source/data-contract/company-profile';

import type { CompanyProfile, CompanyProfileUpdate } from '../../../../shared/source/data-contract/company-profile';
import type { HttpFetcherError } from '../../../../shared/source/http-fetcher/http-fetcher';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../../shared/source/validating-http-fetcher';
import type { Result } from 'true-myth';

type JsonFetcher = ValidatingHttpFetcherWithBaseUrl;

export type CompanyProfileFetchers = {
    readonly fetchCompanyProfile: () => Promise<Result<CompanyProfile, HttpFetcherError>>;
    readonly updateCompanyProfile: (args: {
        readonly payload: CompanyProfileUpdate;
    }) => Promise<Result<CompanyProfile, HttpFetcherError>>;
};

export type CompanyProfileFetchersDependencies = {
    readonly validatingCobrainerApiFetcher: JsonFetcher;
};

export const createCompanyProfileFetchers = (
    dependencies: CompanyProfileFetchersDependencies,
): CompanyProfileFetchers => {
    const { validatingCobrainerApiFetcher } = dependencies;

    const fetchCompanyProfile: CompanyProfileFetchers['fetchCompanyProfile'] = async () => {
        return validatingCobrainerApiFetcher.get(companyProfileSchema, {
            pathname: '/company-profile',
        });
    };

    const updateCompanyProfile: CompanyProfileFetchers['updateCompanyProfile'] = async ({ payload }) => {
        return validatingCobrainerApiFetcher.patchJson(companyProfileSchema, {
            pathname: '/company-profile',
            payload,
        });
    };

    return {
        fetchCompanyProfile,
        updateCompanyProfile,
    };
};
